/**
 * Ensures that the given string ends with a dot (period), unless it ends with a special character.
 *
 * @param {string} [str] - The input string to check and potentially modify.
 * @returns {string} The input string with a dot at the end if needed, or the original string. Returns an empty string if the input is undefined.
 */
export default function ensureDotAtEnd(value) {
  var _value$trim;
  const str = (_value$trim = value == null ? void 0 : value.trim()) != null ? _value$trim : '';
  if (!str) {
    return str;
  }
  const lastChar = str.charAt(str.length - 1);
  if (lastChar === '.' || lastChar === '!' || lastChar === '?' || lastChar === ':') {
    return str;
  }
  return `${str}.`;
}